import React, {Fragment} from "react";
import Header from "./Header";
import logo from '../Assets/HT logo round.png';

const FAQ = () => {
    return (
        <Fragment>
            <Header intro="Frequently Asked Questions" logo={logo}></Header>
        </Fragment>
    )
}

export default FAQ;